import { BallotRecountOutlineIcon } from './BallotRecountOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0B0AD153-4696-4ED2-9AE1-309926B23287
 * name ballot-recount-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ballot-recount-outline.svg
 * tags
 */
export const VoteRecountOutlineIcon = BallotRecountOutlineIcon;
export default VoteRecountOutlineIcon